<template>
  <footer id="gFooter">
    <p>&copy; 2020 ARUCU All Rights Reserved.</p>
  </footer>
</template>

<script>
export default {
  name: 'gFooter'
}
</script>



// WEBPACK FOOTER //
// src/components/footer.vue